/**
 * Filter keys for Select filters(which are shown on the top of screen) in console app.
 */
enum SelectFilterKey {
  PARTICIPANT_TYPE = "participantType",
  COMMUNITY_SPONSOR = "csType",
  DIVISION = "division",
  TAG = "tag",
  ROLE = "role",
  ACTIVITY_DAYS = "activityDays",
  TEXT = "text",
  EVENT_SERIES = "eventSeries",
  MODERATED = "moderated",
  UN_ASSIGNED = "unassigned",
  FAILED = "failed",
  PARTICIPANT_SUB_ROLE = "participantSubRole",
  PROGRAM_TYPE = "programType",
  EVENT_WORKFLOW_SNIPPET = "eventWorkflowSnippet",
  PROGRAM = "programId",
  OUTREACH_TYPE = "outreachType"
}

export default SelectFilterKey;
